<template>
  <div class="home">
      <Chat class="marginal" ></Chat>
  </div>
</template>

<script>
import Chat from '@/components/ChatSingleRoom.vue';
export default {
  name: 'chat',
  components: {
    Chat
  }
}
</script>